import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { PlayerProvider } from "@/context/PlayerContext";

// Pages
import LandingPage from "@/pages/LandingPage";
import AuthPage from "@/pages/AuthPage";
import MusicianDashboard from "@/pages/MusicianDashboard";
import OrganizerDashboard from "@/pages/OrganizerDashboard";
import MusicianProfile from "@/pages/MusicianProfile";
import DiscoverPage from "@/pages/DiscoverPage";

// Components
import { AudioPlayer } from "@/components/AudioPlayer";

const ProtectedRoute = ({ children, allowedType }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#050505]">
        <div className="w-8 h-8 border-2 border-[#CCFF00] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/auth" replace />;
  }
  
  if (allowedType && user.user_type !== allowedType) {
    return <Navigate to={user.user_type === "musician" ? "/dashboard" : "/organizer"} replace />;
  }
  
  return children;
};

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#050505]">
        <div className="w-8 h-8 border-2 border-[#CCFF00] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  
  if (user) {
    return <Navigate to={user.user_type === "musician" ? "/dashboard" : "/organizer"} replace />;
  }
  
  return children;
};

function AppRoutes() {
  return (
    <>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/auth" element={<PublicRoute><AuthPage /></PublicRoute>} />
        <Route path="/discover" element={<DiscoverPage />} />
        <Route path="/musician/:id" element={<MusicianProfile />} />
        <Route 
          path="/dashboard/*" 
          element={
            <ProtectedRoute allowedType="musician">
              <MusicianDashboard />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/organizer/*" 
          element={
            <ProtectedRoute allowedType="organizer">
              <OrganizerDashboard />
            </ProtectedRoute>
          } 
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <AudioPlayer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <PlayerProvider>
          <div className="min-h-screen bg-[#050505]">
            <div className="noise-overlay" />
            <AppRoutes />
            <Toaster 
              position="bottom-right"
              toastOptions={{
                style: {
                  background: '#111111',
                  border: '1px solid rgba(255,255,255,0.1)',
                  color: '#fff',
                },
              }}
            />
          </div>
        </PlayerProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
